import { render, staticRenderFns } from "./ReactionOption.vue?vue&type=template&id=4b7560b3&scoped=true&"
import script from "./ReactionOption.vue?vue&type=script&lang=js&"
export * from "./ReactionOption.vue?vue&type=script&lang=js&"
import style0 from "./ReactionOption.vue?vue&type=style&index=0&id=4b7560b3&lang=scss&scoped=true&"
import style1 from "./ReactionOption.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7560b3",
  null
  
)

/* custom blocks */
import block0 from "./ReactionOption.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports